import { MyPageSupportWidget } from '@marpple/mco-membership-ui';
import { html, View } from 'rune-ts';
import { ConfigSentryF } from '../../../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';
import { MyMembershipTabData } from '../../../../../../../modules/MShop/App/Mypage/MembershipList/S/type';
import { createOnClickInicisTerms } from '../../../../../../../modules/MShop/App/Mypage/MembershipPayMethod/component/terms/InicisTerms';
import { createOnClickPersonalInfoOutsourcing } from '../../../../../../../modules/MShop/App/Mypage/MembershipPayMethod/component/terms/PersonalInfoOutsourcingTerms';
import { createOnClickThirdPartyConsent } from '../../../../../../../modules/MShop/App/Mypage/MembershipPayMethod/component/terms/ThirdPartyConsentTerms';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import {
  MEMBERSHIP_UI_IDENTIFIER,
  my_membership_support_path,
} from '../../../../../features/Membership/constant';
import { not_existing_project_store_message } from '../../../../../features/Membership/constant/message';
import { MembershipErrorEnable } from '../../../../../features/Membership/error/error_enable';
import { MembershipUtilS } from '../../../../../features/Membership/outbound/share';
import { getActivatedSdkWithEvent } from '../../../../../features/Membership/util';
import { makeEmptyScreenNavigate, makeSubScreenNavigate } from '../../../../../shared/app/navigate';
import { navigateTo } from '../../../../../shared/app/util';
import { EXCLUDE_MAKER_MODULE } from '../../../../../shared/constant';
import { Alert } from '../../../../components/cells/Alert/Alert';
import { CreatorShopSupportPage } from '../../../CreatorShopMembership/CreatorShopSupportPage';
import { onIntegratedPaidServiceTermsTextClick } from '../../../PaidServiceTerms/modal';

export class SupportTab extends View<MyMembershipTabData> {
  private _membershipErrorEnable = new MembershipErrorEnable(this);

  get isMobile(): boolean {
    return this.data.layout_options.is_mobile;
  }

  get isApp(): boolean {
    return MShopUtilF.isApp();
  }

  override async onRender() {
    try {
      const client = await getActivatedSdkWithEvent(this.data.membership_token);
      const widget = new MyPageSupportWidget({
        client,
        isMobile: this.isMobile,
        isApp: this.isApp,
        toggleSpinner: MembershipUtilS.toggleSpinner,
        onSeeSupportDetailButtonClick: this.onSeeSupportDetailButtonClick.bind(this),
        onError: this._membershipErrorEnable.onError,
        onIntegratedPaidServiceTermsTextClick: onIntegratedPaidServiceTermsTextClick,
        onClickPersonalInfoOutsourcing: createOnClickPersonalInfoOutsourcing(),
        onClickThirdPartyConsent: createOnClickThirdPartyConsent(),
        onClickInicisTerms: createOnClickInicisTerms(),
        onMySupportMessageButtonClick: this.onMySupportMessageButtonClick.bind(this),
        onScrollLock: MShopUtilF.bodyFixed$,
        onShopButtonClick: this._onShopButtonClick.bind(this),
      });

      widget.render(this.element());
    } catch (e) {
      ConfigSentryF.error(e);
      await this._membershipErrorEnable.openWidgetRenderErrorModal();
    }
  }

  private _onShopButtonClick(shopUrl: string) {
    navigateTo(shopUrl, makeEmptyScreenNavigate);
  }

  // 후원 상세보기 버튼 클릭 시 콜백
  onSeeSupportDetailButtonClick(projectId: string, supportId: string): void {
    navigateTo(
      `/${ET.lang}/@/${my_membership_support_path}/${projectId}/${supportId}`,
      makeSubScreenNavigate,
    );
  }

  async onMySupportMessageButtonClick(projectId: string) {
    const domain_name = this.getDomainName(projectId);
    if (!domain_name) {
      ConfigSentryF.error(`projectId=${projectId} 의 domain_name이 존재하지 않습니다.`);
      await Alert.open({ title: not_existing_project_store_message });
    }

    navigateTo(
      `/${ET.lang}/${domain_name}/membership/support?tab_index=${CreatorShopSupportPage.getSupportPageTabIndex('message')}`,
      makeSubScreenNavigate,
    );
  }

  protected override template() {
    return html`<div class="${MEMBERSHIP_UI_IDENTIFIER} ${EXCLUDE_MAKER_MODULE}"></div>`;
  }

  private getDomainName(projectId: string): string {
    return this.data.project_domain_name_map[projectId] || '';
  }
}
